<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
    :backgroundColor="pattern.backgroundColor"
  >
    <div
      slot="content"
      class="d-flex flex-row"
      :style="{backgroundColor:pattern.cardBackgroundColor}"
    >
      <!-- 标题栏和状态栏占位符 -->
      <van-image
        lazy-load
        :src="data.src"
        class="flex-1"
        :class="{'img-radius':pattern.showImgBorderRadius}"
        mode="widthFix"
        @click="navToDetailPage(data,0)"
      />
      <div
        style="padding:10px"
        class="flex-1 d-flex flex-column justify-content-around align-items-center"
      >
        <div class="title">{{data.title}}</div>
        <div class="subTitle">{{data.subTitle}}</div>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Object,
      default: () => {
        return {
          title: '素描',
          subTitle: '斜面圆柱绘图技巧',
          src: 'https://res.zhifu88.cn/alachuang/755320200508174011/default.png',
          navTo: ''
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: true,
          showRightBorder: true,
          showBottomBorder: true,
          showLeftBorder: true,
          showBorderRadius: false,
          showLeftPadding: false,
          showRightPadding: false,
          showTopPadding: false,
          showBottomPadding: false,
          showImgBorderRadius: true,
          boxType: 'block',
          backgroundColor: 'rgba(255,255,255,0)',
          cardBackgroundColor: 'rgba(255,255,255,1)',
        }
      }
    },
  },
  data () {
    return {

    };
  },
  methods: {
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
  justify-content: space-around;
}

.img-radius {
  border-radius: 12px;
  overflow: hidden;
}
.title {
  font-size: 18px;
  font-weight: bold;
}
.subTitle {
  font-size: 14px;
  font-weight: bold;
}
</style>
